var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights-V0",
    transform: "translate(-323.000000, -525.000000)",
    fill: "#647FB4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-help",
    transform: "translate(323.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,10 C2.25,10 0,7.75 0,5 C0,2.25 2.25,0 5,0 C7.75,0 10,2.25 10,5 C10,7.75 7.75,10 5,10 Z M5,1 C2.8,1 1,2.8 1,5 C1,7.2 2.8,9 5,9 C7.2,9 9,7.2 9,5 C9,2.8 7.2,1 5,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,2 C3.9,2 3,2.9 3,4 L4,4 C4,3.45 4.45,3 5,3 C5.55,3 6,3.45 6,4 C6,5 4.5,5.2 4.5,6.5 L5.5,6.5 C5.5,5.65 7,5.25 7,4 C7,2.9 6.1,2 5,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.5,
    y: 7,
    width: 1,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.48e3596a861a612038deffad6767ece2.svg";
export { ForwardRef as ReactComponent };